/**
 * Router - Navigation management using Navigo
 */

import Navigo from 'navigo';

export class Router {
  constructor(viewContainer, sidebar) {
    this.viewContainer = viewContainer;
    this.sidebar = sidebar;
    this.currentView = null;
    this.router = new Navigo('/');
    this.views = {};
  }

  registerView(route, viewClass) {
    this.views[route] = viewClass;
  }

  setupRoutes() {
    // Dashboard
    this.router.on('/', () => {
      this.loadView('dashboard');
    });

    // Transactions
    this.router.on('/transactions', () => {
      this.loadView('transactions');
    });

    // Reports
    this.router.on('/reports', () => {
      this.loadView('reports');
    });

    // Import/Export
    this.router.on('/import-export', () => {
      this.loadView('import-export');
    });

    // Settings
    this.router.on('/settings', () => {
      this.loadView('settings');
    });

    // 404 - Redirect to dashboard
    this.router.notFound(() => {
      this.router.navigate('/');
    });

    // Resolve current route
    this.router.resolve();
  }

  loadView(viewName) {
    // Clean up current view if exists
    if (this.currentView && this.currentView.destroy) {
      this.currentView.destroy();
    }

    // Update sidebar active state
    if (this.sidebar) {
      this.sidebar.updateRoute(viewName);
    }

    // Load new view
    const ViewClass = this.views[viewName];
    if (ViewClass) {
      this.currentView = new ViewClass(this.viewContainer);
      this.currentView.render();
    } else {
      // Fallback: show placeholder
      this.viewContainer.innerHTML = `
        <div class="page-header">
          <h1 class="page-title">Em Desenvolvimento</h1>
          <p class="page-subtitle">Esta seção está sendo construída.</p>
        </div>
      `;
    }
  }

  navigate(path) {
    this.router.navigate(path);
  }

  start() {
    this.setupRoutes();
  }
}
